import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from '../api.service'
import { ObservablesService } from '../observables.service'
@Component({
  selector: 'app-super-admin-header',
  templateUrl: './super-admin-header.component.html',
  styleUrls: ['./super-admin-header.component.scss']
})
export class SuperAdminHeaderComponent implements OnInit {
  closeResult: string;
  dataForm:FormGroup
  unitFormStatus:boolean = true
  units:any=[]
  industries:any=[]
  editStatus:boolean = false;
  editUnitId:any=''
  editIndustryId:any=''
  activeBtn:any=1;
  constructor(private router:Router, private observables:ObservablesService, private api:ApiService, private modalService: NgbModal,private fb:FormBuilder) { }

  ngOnInit() {
  }
  openMenu(){
    this.observables.setMenuStatus({menuState:'in'})
  }

  gotoHome(){
    this.router.navigate(['/super-admin-dashboard'])
  }

  addBusiness(){
    this.router.navigate(['/add-business'])
  }

  addIndustry(content){
    this.unitFormStatus = false;
    this.getIndustries()
    this.openModal(content);
  }

  addUnit(content) {
    this.unitFormStatus = true;
    this.getUnits()
    this.openModal(content);
  }
 openModal(content){
   this.dataForm= this.fb.group({
     name:[null,Validators.required]
   });
   this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
     this.closeResult = `Closed with: ${result}`;
   }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
   });
 }

 private getDismissReason(reason: any): string {
   this.unitFormStatus = false;
   if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
   } else {
     return  `with: ${reason}`;
   }
 }

 getUnits(){
   this.api.send('findDb',{
     table:'units'
   }).then((res:any)=>{
     this.units = res.data;
   })
 }
 getIndustries(){
   this.api.send('findDb',{
     table:'industries'
   }).then((res:any)=>{
     this.industries = res.data;
   })
 }

 save(value){
   let table:string='';
   if(this.unitFormStatus){
     table = "units";
   }else{
     table = "industries";
   }

   this.api.send("insertDb",{
     table:table,
     data:value
   }).then((res:any)=>{
     if(res.data.affectedRows){
       this.dataForm.reset()
       if(this.unitFormStatus){
         this.getUnits()
       }else{
         this.getIndustries()
       }
       this.observables.showToastMessage({type:0,message: table+' saved..'});
     }else{
      this.observables.showToastMessage({type:1,message:table+ ' not saved..'});
     }
   })
 }

 editIndustry(data){
   this.editIndustryId = data.id;
   this.dataForm.patchValue({name:data.name});
   this.editStatus = true;
 }
 editUnit(data){
   this.editUnitId = data.id;
   this.dataForm.patchValue({name:data.name});
   this.editStatus = true;
 }
 cancelEdit(){
   this.editIndustryId = '';
   this.editUnitId = '';
   this.dataForm.reset();
   this.editStatus = false;
 }

 updateData(value,data){

   if(confirm("Are you sure to update "+data+"?")){
     this.api.send("findDb",{
       table:(this.unitFormStatus)?'units':'industries',
       conditions:[{name:value.name}]
     }).then((res:any)=>{
       if(res.data.length > 0){
         this.observables.showToastMessage({type:1,message:data+" Already Exists."})
       }else{
         this.api.send("updateDb",{
           table:(this.unitFormStatus)?'units':'industries',
           data:{name:value.name},
           conditions:[{id:(this.unitFormStatus)?this.editUnitId:this.editIndustryId}]
         }).then((res1:any)=>{
           if(res1.data.affectedRows){
             if(this.unitFormStatus){
               this.getUnits()
             }else{
               this.getIndustries()
             }
             this.cancelEdit()
             this.observables.showToastMessage({type:0,message:data+" Updated.."})
           }else{

             this.observables.showToastMessage({type:1,message:"Can\'t update "+data+", Try again."})
           }
         })
       }
     })
   }
 }

 deleteData(id,data){
   if(confirm("Are you sure to delete "+data+"?")){

     this.api.send("deleteDb",{
       table:(this.unitFormStatus)?'units':'industries',
       conditions:[{id:id}]
     }).then((res1:any)=>{
       if(res1.data.affectedRows){
         if(this.unitFormStatus){
           this.getUnits()
         }else{
           this.getIndustries()
         }
         this.cancelEdit()
         this.observables.showToastMessage({type:0,message:data+" Deleted.."})
       }else{

         this.observables.showToastMessage({type:1,message:"Can\'t delete "+data+", Try again."})
       }
     })
   }
 }
}
